module.exports = __webpack_public_path__ + "static/media/PTC.4fafc370.png";